import { render } from "./DropdownTable.vue?vue&type=template&id=61180482"
import script from "./DropdownTable.vue?vue&type=script&lang=js"
export * from "./DropdownTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__